import { assign } from '../../core/utils';
import { getShouldCollectApiError, getCurrentTimeStamp } from './utils';
import { REQUEST_LOG_START_KEY, REQUEST_LOG_END_KEY } from './constant';
export * from './model';
function logInterceptorGenerator(instanceConfig) {
    var logConfig = (instanceConfig || {}).logConfig;
    var logger = (logConfig || {}).logger;
    if (!logger) {
        return;
    }
    // 发出请求拦截器
    var requestInterceptor = function (config) {
        try {
            var startTime = getCurrentTimeStamp();
            config.metadata = assign({}, config.metadata || {}, { startTime: startTime });
            logger.collect('CUSTOM', REQUEST_LOG_START_KEY, {
                url: config.url,
                api: config.url,
                startTime: startTime,
            });
        }
        catch (e) {
            var message = "\u6536\u96C6\u53D1\u51FA\u8BF7\u6C42\u65E5\u5FD7\u9519\u8BEF: " + (e && e.message);
            logger.collect('CUSTOM', 'ESHOP_REQUEST_LOG_ERROR', {
                message: message,
                config: config,
            });
        }
        return config;
    };
    // 2xx响应拦截器
    var responseFullfilledInterceptor = function (response) {
        var _a, _b;
        var config = response.config;
        try {
            var endTime = getCurrentTimeStamp();
            var startTime = config.metadata && config.metadata.startTime || endTime;
            var requestConfig = response.config;
            var resData = typeof response.data === 'object' && response.data ? response.data : {};
            var error_msg = resData.error_msg || resData.errMsg || resData.errorMsg || resData.message;
            var params = {
                url: config.url,
                api: config.url,
                cost: endTime - startTime,
                status: response.status,
                error_msg: error_msg,
                result: resData.result,
            };
            var shouldCollectApiError = getShouldCollectApiError(instanceConfig, requestConfig);
            if (shouldCollectApiError(response)) {
                // 响应成功，但非业务成功状态需要额外上传请求参数和响应数据
                params = assign({}, params, {
                    res: response.data,
                    data: (_a = response.config) === null || _a === void 0 ? void 0 : _a.data,
                    params: (_b = response.config) === null || _b === void 0 ? void 0 : _b.params,
                });
            }
            logger.collect('CUSTOM', REQUEST_LOG_END_KEY, params);
        }
        catch (e) {
            var message = "\u6536\u96C62xx\u54CD\u5E94\u65E5\u5FD7\u9519\u8BEF: " + (e && e.message);
            logger.collect('CUSTOM', 'ESHOP_REQUEST_2XX_LOG_ERROR', {
                message: message,
                response: response
            });
        }
        return response;
    };
    // 非2xx响应拦截器
    var responseRejectedInterceptor = function (error) {
        try {
            var _a = error || {}, config = _a.config, response = _a.response, message = _a.message;
            var _b = response || {}, status_1 = _b.status, res = _b.data;
            var configWithMetadata = (config || {});
            var url = configWithMetadata.url, metadata = configWithMetadata.metadata, data = configWithMetadata.data;
            var api = url;
            var endTime = getCurrentTimeStamp();
            var startTime = metadata && metadata.startTime || endTime;
            var cost = endTime - startTime;
            var params = {
                url: url,
                api: api,
                res: res,
                cost: cost,
                status: status_1,
                beyond2xx: 1,
                data: data,
                params: configWithMetadata.params,
                message: message || '发出请求失败, 缺少错误信息',
            };
            logger.collect('CUSTOM', REQUEST_LOG_END_KEY, params);
        }
        catch (e) {
            var message = "\u6536\u96C6\u975E2xx\u54CD\u5E94\u65E5\u5FD7\u9519\u8BEF: " + (e && e.message);
            logger.collect('CUSTOM', 'ESHOP_REQUEST_NOT_2XX_LOG_ERROR', {
                message: message,
                error: error,
            });
        }
        return Promise.reject(error);
    };
    return {
        requestInterceptor: requestInterceptor,
        responseFullfilledInterceptor: responseFullfilledInterceptor,
        responseRejectedInterceptor: responseRejectedInterceptor,
    };
}
export default logInterceptorGenerator;
//# sourceMappingURL=index.js.map